export function formatDate(date: string, type?: 'time') {
  const dateObj = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  if (type === 'time') {
    options.hour = '2-digit'
    options.minute = '2-digit'
    options.second = '2-digit'
  }

  return dateObj.toLocaleDateString('en-US', options)
}

export function daysAgo(date: string) {
  const now = new Date()
  const diffTime = Math.abs(now.getTime() - new Date(date).getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`
}

export function formatDateWithDaysAgo(date: string, type?: 'time', reverse?: boolean) {
  if (reverse) {
    return `${daysAgo(date)} (${formatDate(date, type)})`
  }
  return `${formatDate(date, type)} (${daysAgo(date)})`
}

const WEEKDAY_NAMES = [
  'Mondays',
  'Tuesdays',
  'Wednesdays',
  'Thursdays',
  'Fridays',
  'Saturdays',
  'Sundays'
]

/**
 * Formats a pod's weekly meeting day + time (both stored/displayed in UTC, no
 * timezone conversion) into a readable string, e.g. "Tuesdays at 18:00 UTC".
 * Returns null when either value is missing (meeting time not set).
 */
export function formatMeetingTime(
  dayOfWeek: number | null | undefined,
  time: string | null | undefined
): string | null {
  if (dayOfWeek === null || dayOfWeek === undefined || !time) return null
  const dayName = WEEKDAY_NAMES[dayOfWeek]
  if (!dayName) return null
  const [hours, minutes] = time.split(':')
  return `${dayName} at ${hours}:${minutes} UTC`
}